import { numberRegex } from './regex';

const validFinnkode = (finnkode?: string) => finnkode !== undefined && numberRegex.test(finnkode);

export default validFinnkode;
